export default function Hero({ event }) {
  return (
    <div className="relative w-full overflow-hidden pt-16">
      {/* BLURRED BACKGROUND */}
      <div className="absolute inset-0">
        <img
          src={event.flyer_horizontal}
          alt=""
          className="w-full h-full object-cover blur-sm scale-110 opacity-40"
        />

        {/* DARK BASE */}
        <div className="absolute inset-0 bg-[#021610]/70" />

        {/* BOTTOM GRADIENT (your nice effect) */}
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#021610]" />
      </div>

      {/* CONTENT */}
      <div className="relative z-10 max-w-6xl mx-auto px-4">
        {/* SMALL FLYER */}
        <div className="flex justify-center">
          <div className="w-full max-w-md md:max-w-lg rounded-xl overflow-hidden shadow-lg border border-green-900/30 bg-black/20 backdrop-blur-sm">
            <img
              src={event.flyer_horizontal}
              alt={event.name}
              className="w-full h-full object-contain"
            />
          </div>
        </div>

        {/* TEXT (LEFT ALIGNED) */}
        <div className="mt-8">
          <p className="text-green-400 text-sm tracking-widest">EVENTO</p>

          <h1 className="text-2xl md:text-4xl font-bold leading-tight mt-2">
            {event.name}
          </h1>
        </div>
      </div>
    </div>
  );
}
